"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./data/types");
var Equipment = /** @class */ (function () {
    function Equipment() {
        // @ts-ignore
        this[_a] = null;
        // @ts-ignore
        this[_b] = null;
        // @ts-ignore
        this[_c] = null;
        // @ts-ignore
        this[_d] = null;
        // @ts-ignore
        this[_e] = null;
        // @ts-ignore
        this[_f] = null;
        // @ts-ignore
        this[_g] = null;
        // @ts-ignore
        this[_h] = null;
    }
    Equipment.prototype.findSlotByItemId = function (itemId) {
        var e_1, _j;
        var symbolSlots = Object.getOwnPropertySymbols(this);
        try {
            for (var symbolSlots_1 = __values(symbolSlots), symbolSlots_1_1 = symbolSlots_1.next(); !symbolSlots_1_1.done; symbolSlots_1_1 = symbolSlots_1.next()) {
                var slot = symbolSlots_1_1.value;
                if (this[slot] &&
                    this[slot].id === itemId) {
                    return slot;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (symbolSlots_1_1 && !symbolSlots_1_1.done && (_j = symbolSlots_1.return)) _j.call(symbolSlots_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    };
    Equipment.prototype.getEquipped = function () {
        var e_2, _j;
        var equipped = [];
        try {
            for (var _k = __values(Object.getOwnPropertySymbols(this)), _l = _k.next(); !_l.done; _l = _k.next()) {
                var equipmentSymbol = _l.value;
                var equipment = this[equipmentSymbol];
                // @ts-ignore
                if (equipment && equipped.indexOf(equipment) < 0) {
                    // @ts-ignore
                    equipped.push(equipment);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return equipped;
    };
    Equipment.prototype.equip = function (item) {
        var equipped = false;
        if (item.category === types_1.ItemCategories.Weapon) {
            // we have a weapon, assign to hand
            // if it's a multi slit
            if (item.isMultiSlot) {
                // unequip right
                if (this[types_1.WeaponSlots.RightHand]) {
                    this[types_1.WeaponSlots.RightHand].equipped = false;
                }
                // unequip left
                if (this[types_1.WeaponSlots.LeftHand]) {
                    this[types_1.WeaponSlots.LeftHand].equipped = false;
                }
                // equip both
                this[types_1.WeaponSlots.RightHand] = item;
                this[types_1.WeaponSlots.LeftHand] = item;
                equipped = true;
            }
            else {
                // we have a one handed weapon
                // is right hand free?
                if (!this[types_1.WeaponSlots.RightHand]) {
                    // yes, equip
                    this[types_1.WeaponSlots.RightHand] = item;
                    equipped = true;
                }
                else {
                    // no, right hand is not free
                    // is left hand free?
                    if (!this[types_1.WeaponSlots.LeftHand]) {
                        this[types_1.WeaponSlots.LeftHand] = item;
                        equipped = true;
                    }
                    else {
                        // no, both hands taken
                        // if we unquipped a multi slot weapon, unequip the other hand as well
                        if (this[types_1.WeaponSlots.RightHand].isMultiSlot) {
                            this[types_1.WeaponSlots.LeftHand] = null;
                        }
                        // unequip what ever is in right hand
                        this[types_1.WeaponSlots.RightHand].equipped = false;
                        // equip ro right hand
                        this[types_1.WeaponSlots.RightHand] = item;
                        equipped = true;
                    }
                }
            }
        }
        else if (item.category === types_1.ItemCategories.Armor) {
            var slot = item.slot;
            if (this[slot]) {
                this[slot].equipped = false;
            }
            this[slot] = item;
            equipped = true;
        }
        else if (item.category === types_1.ItemCategories.Jewelery) {
            // we have a jewelery, assign to hand
            if (!this[types_1.JewelerySlots.Left]) {
                this[types_1.JewelerySlots.Left] = item;
                equipped = true;
            }
            else {
                if (this[types_1.JewelerySlots.Right]) {
                    this[types_1.JewelerySlots.Right].equipped = false;
                }
                this[types_1.JewelerySlots.Right] = item;
                equipped = true;
            }
        }
        return equipped;
    };
    Equipment.prototype.unequip = function (itemId) {
        // @ts-ignore
        this[this.findSlotByItemId(itemId)] = null;
        // @ts-ignore
        this[this.findSlotByItemId(itemId)] = null;
        return true;
    };
    Equipment.hydrate = function (obj) {
        var equipment = Object.assign(new Equipment(), obj);
        return equipment;
    };
    Equipment.prototype.tick = function () {
        // todo tick equipment
    };
    return Equipment;
}());
exports.default = Equipment;
_a = types_1.ArmorSlots.Head, _b = types_1.ArmorSlots.Body, _c = types_1.ArmorSlots.Legs, _d = types_1.ArmorSlots.Feet, _e = types_1.WeaponSlots.LeftHand, _f = types_1.WeaponSlots.RightHand, _g = types_1.JewelerySlots.Left, _h = types_1.JewelerySlots.Right;
